module.exports = __webpack_public_path__ + "img/15_96.2259f20d.png";